import { getSessionManager } from '../helpers';
export function isProcessorShouldStop(isActive) {
    var _a;
    return !isActive || !!((_a = getSessionManager()) === null || _a === void 0 ? void 0 : _a.isIdleActive);
}
